/**
 * @desc 更新计划入库单状态
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InPlanStatusRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/inPlan/updateInPlanMasterStatus`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
